import { JsonObject } from 'json2typescript';
import { CustomCurrencySymbolsInterface } from '../interfaces/custom-currency-symbols.interface';

@JsonObject('CustomCurrencySymbolsModel')
export class CustomCurrencySymbolsModel
  implements CustomCurrencySymbolsInterface
{
  symbol?: string;
  currency?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
